import React from "react";
import { Empty, Spin } from "antd";
import RoleDetailsCard from "../components/roles/roles-details-card/RolesDetailsCard";
import { useSelector } from "react-redux";
import { getUserRoleList } from "@src/redux/index";

const Roles: React.FC = () => {
  const { result: getUserListResult, loading: getUserListLoading } =
    useSelector(getUserRoleList);

  return (
    <div>
      {getUserListLoading ? (
        <div
          className="spinner-container"
          style={{ textAlign: "center", marginTop: "20px" }}
        >
          <Spin size="large" />
        </div>
      ) : getUserListResult?.items?.length ? (
        <div className="roles-container">
          {getUserListResult.items.map((profile: any, index: number) => (
            <RoleDetailsCard key={index} profile={profile} />
          ))}
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Empty description="No roles found" className="no_device_found" />
        </div>
      )}
    </div>
  );
};

export default Roles;
